<template>
      <v-dialog v-model="open" width="50%" :fullscreen="$root.isTouch" persistent>
            <v-card>
                  <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close">
                              <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title class="headline text-white" v-html="titulo"></v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="p-0">
                        <v-container fluid grid-list-sm>
                              <v-row dense class="mt-5 mb-5">
                                    <v-col cols="12" sm="12">
                                          <v-data-table :headers="listGeneral.cabeceraResumen"
                                                :items="listGeneral.detalleResumen" dense class="elevation-2"
                                                hide-default-footer>
                                                <template v-slot:item.totalPrima="{ item }">
                                                      {{ `$ ${_.round(item.totalPrima,2)}` }}
                                                </template>
                                          </v-data-table>
                                    </v-col>
                              </v-row>
                        </v-container>
                  </v-card-text>
            </v-card>
      </v-dialog>
</template>

<script>
      export default {
            name: 'ModalTableComponent',
            inject: ['close'],
            props: {
                  open: {
                        type: Boolean,
                        default: false
                  },
                  titulo: {
                        type: String,
                        default: ''
                  },
                  listGeneral: {
                        type: Object,
                        default: {}
                  }
            },
      }
</script>